import axios from "axios";
import { Apis, BaseUrl } from "../../config";

import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const feesList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "fees_List_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.feeslist}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { sys_user_id: user_profile_id, role_id: role_id },
    });
    dispatch({ type: "fees_List_Success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "fees_List_failure",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const deleteFees = (svcfee_id) => async (dispatch) => {
  const { token, role_id } = getSession();

  dispatch({ type: "fees_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.feeslist}${svcfee_id}`,
      {
        svcfee_active_yn: "N",
        sys_user_id: svcfee_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "fees_delete", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "fees_delete_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};

export const createFees = (values, history) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_fees_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newFees}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_fees_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_fees_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const editFees = (values, feesId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_fees_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.newFees}/${feesId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_fees_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_fees_failure",
      payload: error.response.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

export const setCurrentData = (data) => (dispatch) => {
  dispatch({ type: "set_fees_details", payload: data });
};
